import React, { useEffect, useRef, useState } from "react";
import { Navigation } from "./navigation";
import classes from "./common.module.scss";
import {
  BusinessIcon,
  GroupIcon,
  PlanIcon,
  PlantIcon,
  ScaleIcon,
  ShieldIcon,
} from "../../assets/svg";
import JsonData from "../../constants/data.json";
import "./service.css";

const iconStyles = {
  boxShadow: "10px 10px 10px rgba(0, 0, 0, 0.05)",
  background: "linear-gradient(to right, #009257 0%, #00ff99 100%)",
  width: "50px",
  height: "50px",
  padding: "13px 0",
  borderRadius: "50%",
  fill: "#fff",
};

const DetailServices = () => {
  const [landingPageData, setLandingPageData] = useState(JsonData);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const getIconFirstRow = (i) => {
    switch (i) {
      case 0:
        return <BusinessIcon style={iconStyles} />;
      case 1:
        return <ScaleIcon style={iconStyles} />;
      case 2:
        return <ShieldIcon style={iconStyles} />;
      case 3:
        return <PlantIcon style={iconStyles} />;
      case 4:
        return <GroupIcon style={iconStyles} />;
      case 5:
        return <PlanIcon style={iconStyles} />;
      case 6:
        return <BusinessIcon style={iconStyles} />;
      case 7:
        return <ScaleIcon style={iconStyles} />;
      case 8:
        return <ShieldIcon style={iconStyles} />;
      case 9:
        return <GroupIcon style={iconStyles} />;
      case 10:
        return <PlanIcon style={iconStyles} />;
      case 11:
        return <BusinessIcon style={iconStyles} />;
      case 12:
        return <ScaleIcon style={iconStyles} />;
      case 13:
        return <ShieldIcon style={iconStyles} />;
      case 14:
        return <PlantIcon style={iconStyles} />;
      case 15:
        return <GroupIcon style={iconStyles} />;

      default:
        return <></>;
    }
  };

  const spineRef = useRef(null);
  const nodeRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.3 }
    );

    nodeRefs.current.forEach((node) => {
      if (node) observer.observe(node);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <Navigation />
      <div className={classes.detailServiceContainer}>
        <h2>Explore services for your industry</h2>
        <p>Strategic Automation Pipeline</p>
      </div>
      <div className="flow-section container">
        <div className="spine" ref={spineRef}>
          <div className="spine-line"></div>
        </div>
        {landingPageData?.Services?.map((service, index) => (
          <div
            className={`node ${index % 2 === 0 ? "left" : "right"}`}
            key={index}
            ref={(el) => (nodeRefs.current[index] = el)}
          >
            <div className="node-dot"></div>
            <div className="node-card">
              <div className="node-icon">{getIconFirstRow(index)}</div>
              <div className="node-content">
                <h3>{service.name}</h3>
                <div className="description">
                  {service.text}
                  <p>
                    <strong> User Benefit:</strong> {service.text1}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default DetailServices;
